import { isEqual } from 'lodash';
import prepareCategoryFilters, { QueryFilters } from './prepareCategoryFilters';

const isFiltersEmpty = (filter: QueryFilters) => isEqual(filter, prepareCategoryFilters());

export default isFiltersEmpty;
